module.exports = __webpack_public_path__ + "img/target_g.bc8f27a7.svg";